import { IDomainServiceDetails, IExposureServiceInfo } from "./PrivacyExposure.model";
import { RemediationServiceDetails } from "./Remediation.model";

export interface ItemsObjectInfo {
    gotAllItemsInList: boolean;
    noOfItems: number;
    listOfItems: Array<PrivacyIssue|IDomainServiceDetails>;
    zero_state: any;
}

export class PrivacyIssue {
    _internalID: number;
    issue_id: string;
    type: PrivacyIssueType;
    service_info?: any;
    issue_date: Date;
    status: IssueActionStatus;
    actions: PrivacyIssueAction[];
    breach_info?: PrivacyIssueInfo;
    other_info: PrivacyIssueOtherInfo;
    impersonation_confirmed?: boolean;
    interface: any;
    _interface_?: any;
    info: any;
    new_until?: Date;
    created_at: Date;

    breach_details: PrivacyIssueOtherInfo;
    issue_actions: PrivacyIssueAction[];
    exposed_data: {[key: string]: DataClassInfo}
}

export enum PrivacyIssueType {
    IMPERSONATION = 'impersonation',
    BREACH = 'breach',
    RECORD = 'record',
    EXPOSURE = 'exposure',
}

export enum IssueActionStatus {
    NEW = 'new',
    DONE = 'done',
    UNDO = 'undo',
    PROGRESS = 'progress',
    SKIP = 'skip',
    CONFIRMED_IMPERSONATION = 'confirmed_impersonation',
    CONFIRMED_PERSONAL_PROFILE = 'confirmed_personal_profile',
    CONFIRMED_SOMETHING_ELSE = 'confirmed_something_else',
    CONFIRMED = 'confirmed',
    REJECTED = 'rejected',
}

export class PrivacyIssueAction {
    issue_id: string; //* se foloseste doar la parsarea datelor in PrivacyService
    action_id: string;
    title: string;
    description: string;
    status: IssueActionStatus;
    service: IssuesService;
    type: ActionType;
    link: string;
    privacy_score_change: number;
    interface?: any;
    actionService?: any;
    scoreText: string;
}

export enum ActionType {
    CHANGE_PASSWORD = 'change_password',
    ACTIVATE_2FA = 'activate_2fa',
    CONTACT_BANK = 'contact_bank',
    CONTACT_AUTHORITIES = 'contact_authorities',
    CONFIRM_IMPERSONATION = 'confirm_impersonation',
    DELETE_ACCOUNT = 'delete_account',
    NEVER_USED_SERVICE = 'never_used_service',
    CONFIRM_EXPOSURE = 'confirm_exposure',
    FAKE_PROFILE_REMEDIATION = 'fake_profile_remediation',
    IMPLICIT = 'implicit'
}

export enum BreachType {
    BREACH = 'breach',
    COLLECTION = 'collection'
}

export const NormalBreachActions = new Set([ActionType.CHANGE_PASSWORD, ActionType.ACTIVATE_2FA]);
export const SpecialBreachActions = new Set([ActionType.DELETE_ACCOUNT, ActionType.NEVER_USED_SERVICE]);

export class PrivacyIssueInfo {
    breach_date: Date;
    exposed: number;
    dataclasses: string[];
    domain: string;
    title: string;
    story_urls: string[];
    is_verified: boolean;
}

export class PrivacyIssueOtherInfo {
    breach_id: string;
    breachName: string;
    data_classes: string[];
    level: number;
    title: string;
    short: string;
    long: string;
    description: string;
    service: IssuesService;
    issue_relevance: IssueActionStatus;
    profileLink?: string;
    privacy_score_impact?: number;
    occurred_at: Date;
    total_records?: number;
    collection?: boolean;
    exposed;
}

export class DataClassInfo {
    value: string;
    masked: string;
    clear: string;
}

export class IssuesService {
    name: string;
    logo?: string;
    domain?: string;
    homepage_url?: string;
    is_email_service: boolean;
}

export interface IExposureIssue {
    issue_id: string;
    display: string;
    type: PrivacyIssueType;
    created_at: Date;
    updated_at: Date;
    new_until: Date;
    issue_actions: Array<any>;
    exposure_type: string;
    confirmation_status: string;
    new_label: boolean;
    reportedService: boolean;
    remediation: RemediationServiceDetails;
    info: Array<IExposureIssueInfo>;
    infoCurrentService: IExposureIssueInfo;
    interface: IExposureIssueInterface;
    servicesFound: Array<IExposureServiceInfo>;
    direction?: string;
}

export interface IExposureIssueInfo {
    source: string;
    last_seen: string;
    occurred_at: string;
    domain: string;
    service_id: string;
}

export interface IExposureIssueInterface {
    specialDisplay?: string;
}

export interface IIssueActionInterface {
    actionService: string;
    title: string;
    description: string;
    titleDone: string;
    descriptionDone: string;
    icon: string;
    status: string;
    type: string;
    privacy_score_change: number;
    scoreText: string;
    scoreLeftOut: string;
}